import { ToastUtility, type ToastClickEventArgs } from "@syncfusion/ej2-vue-notifications";

const toasts = new Map<string, any>();

interface ToastOptions {
    onClick: (args: ToastClickEventArgs) => void;
};

interface ToastPosition {
    X: 'Left' | 'Center' | 'Right';
    Y: 'Top' | 'Bottom';
}

export const Toast = {
    show: (message: string, title: string, type: string, options?: ToastOptions,
        position: ToastPosition = { X: 'Center', Y: 'Top' }) => {
        const key = `${type}:${title}:${message}`;

        if (toasts.has(key)) {
            return; // Toast já está aberto com essa mensagem
        }

        ToastUtility.show({
            title,
            content: message,
            cssClass: `e-toast-${type}`,
            timeOut: 2000,
            position,
            showCloseButton: true,
            showProgressBar: true,
            click: (args) => {
                if (options?.onClick) {
                    options.onClick(args);
                }
                args.toastObj.hide();
            },
            beforeOpen: (args) => {
                toasts.set(key, args.toastObj);
            },
            close: () => {
                toasts.delete(key);
            },
        }, 'warning');
    },
    success(message: string, title: string = "Sucesso") {
        Toast.show(message, title, 'success');
    },
    warning(message: string, title: string = "Atenção") {
        Toast.show(message, title, 'warning');
    },
    error(message: string, title: string = "Erro") {
        Toast.show(message, title, 'danger');
    },
    info(message: string, title: string = "Informação") {
        Toast.show(message, title, 'info');
    },
    notification(message: string, title: string = "Nova notificação", options?: ToastOptions) {
        Toast.show(message, title, 'info', options, { X: 'Left', Y: 'Bottom' });
    },
}